
import { Participant } from "@/api/dtos";
import useParticipantSourceDataFindings from "@/hooks/data/useParticipantSourceDataFindings";
import useParticipantSourceDataEventStatuses from "@/hooks/data/useParticipantSourceDataEventStatuses";
import useParticipants from "@/hooks/data/useParticipants";
import useSourceData from "@/hooks/data/useSourceData";
import { createContext } from "react"

export interface IParticipantSourceDataFindingsContext extends ReturnType<typeof useParticipantSourceDataFindings> {
}

export const ParticipantSourceDataFindingsContext = createContext<IParticipantSourceDataFindingsContext>({
    data: undefined,
    itemMap: {},
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ParticipantSourceDataFindingsContext;